module.exports = __webpack_public_path__ + "img/icn_disinterested_disable.f391b7f2.svg";